import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import * as RolesRouteMap from 'app-models';
import { take } from 'rxjs/operators';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from '@angular/router';

class APIBeneficiaryPersonalDetails {
    constructor(http) {
        this.http = http;
        this.countryDataSource = new BehaviorSubject({ listCountries: [] });
    }
    getBeneficiaryProfileInformation(visatype, beneficiaryId, data) {
        return this.http.get(`/${visatype}/beneficiary/${beneficiaryId}/personalDetails?taskStepId=${data.stepId}&petitionId=${data.petitionId}`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    getCountry() {
        return this.http.get('/countries').pipe(map((response) => {
            if (response.data) {
                this.countryDataSource.next({ listCountries: response.data });
                return response.data;
            }
        }));
    }
    getCountryWithoutUSA() {
        return this.http.get('/countriesNonUsa').pipe(map((response) => {
            if (response.data) {
                this.countryDataSource.next({ listCountries: response.data });
                return response.data;
            }
        }));
    }
    getCachedCountryList() {
        return this.countryDataSource.asObservable();
    }
    getStates(countryCode) {
        return this.http.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
}
APIBeneficiaryPersonalDetails.ɵfac = function APIBeneficiaryPersonalDetails_Factory(t) { return new (t || APIBeneficiaryPersonalDetails)(i0.ɵɵinject(i1.HttpClient)); };
APIBeneficiaryPersonalDetails.ɵprov = i0.ɵɵdefineInjectable({ token: APIBeneficiaryPersonalDetails, factory: APIBeneficiaryPersonalDetails.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIBeneficiaryPersonalDetails, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseBeneficiaryPersonalDetailsLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostructionService, router) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.router = router;
        this.userType = '';
        this.observableSubscription$ = new Subject();
        this.questionnaire = false;
        this.userType = sessionStorage.getItem('userTypeRole');
        this.disabledControls = false;
        this.typeOfButton = null;
        this.requiredFields = {};
        this.missingValueFalg = false;
        this.questionnaire = window.location.pathname === "/beneficiary-profile/profile" ? true : false;
    }
    ngOnInit() {
        this.userType = sessionStorage.getItem('userTypeRole');
    }
    loadInit() {
        // Get Specific step details by passing step code
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            if (data && data.id) {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
                this.stepDetails = data;
                this.toggleControlsStatus();
                this.getBeneProfileInformation();
            }
        });
    }
    getBeneProfileInformation() {
        this.apiService.getBeneficiaryProfileInformation(this.inputData.visatype, this.stepDetails.beneficiaryId, this.inputData).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response && response.data && response.data.immigrationDetails &&
                response.data.immigrationDetails.arrivalStateProvinceCode &&
                response.data.immigrationDetails.arrivalCountryCode &&
                !response.data.immigrationDetails.arrivalStateProvinceName) {
                this.apiService.getStates(response.data.immigrationDetails.arrivalCountryCode)
                    .pipe(take(1))
                    .subscribe((states) => {
                    response.data.immigrationDetails.arrivalStateProvinceName =
                        states
                            .find(state => state.stateProvinceCode === response.data.immigrationDetails.arrivalStateProvinceCode)
                            .stateProvinceName;
                    this.beneficiaryPersonalDetails = response.data;
                });
            }
            else {
                this.beneficiaryPersonalDetails = response.data;
            }
        });
    }
    // To Verify Missing Fields
    handleVerify() {
        this.missingValueFalg = false;
        this.requiredFields = {
            alienRegNo: false,
            benForeignAddress: {
                addressLine1: false,
                city: false,
                countryName: false,
                postCode: false,
                state: false,
            },
            benCurrentAddress: {
                addressLine1: false,
                city: false,
                countryName: false,
                postCode: false,
                state: false,
            },
            birthCity: false,
            birthCountry: false,
            birthState: false,
            citizenShip: false,
            countryCode: false,
            dob: false,
            emailId: true,
            firstName: true,
            gender: false,
            immigrationDetails: {
                placeOfLastArrival: false,
                modeOfTravel: false,
                city: false,
                state: false,
                arrivalCity: false,
                arrivalCountryCode: false,
                arrivalCountryName: false,
                arrivalStateProvinceCode: false,
                arrivalStateProvinceName: false,
                arrivalDate: false,
                admittedAs: false,
                classOfAdmission: false,
                i94ExpiryDate: false,
                i94Number: false
            },
            lastName: true,
            mobileNo: false,
        };
        if (!this.iterateRequiredFileds(this.requiredFields, null)) {
            if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                this.updateStepStatus('INPROGRESS');
            }
            this.toastr.success('Fields validation is successful', 'Success');
        }
        else {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Check the missing fields');
        }
    }
    iterateRequiredFileds(obj, parentKey) {
        for (const key in obj) {
            if (parentKey) {
                // for object inside Obj
                if (obj[key] && (this.beneficiaryPersonalDetails[parentKey] === null ||
                    this.beneficiaryPersonalDetails[parentKey][key] === null ||
                    this.beneficiaryPersonalDetails[parentKey][key] == undefined ||
                    this.beneficiaryPersonalDetails[parentKey][key] == '')) {
                    this.missingValueFalg = true;
                }
            }
            else if (key === 'immigrationDetails' || key === 'benForeignAddress' || key === 'benCurrentAddress') {
                this.iterateRequiredFileds(this.requiredFields[key], key);
            }
            else if (this.beneficiaryPersonalDetails[key] && (typeof this.beneficiaryPersonalDetails[key] === 'object')) {
                this.iterateRequiredFileds(this.requiredFields[key], key);
            }
            else {
                // for dirct child within Obj
                if (obj[key] && (this.beneficiaryPersonalDetails[key] === null ||
                    this.beneficiaryPersonalDetails[key] == undefined ||
                    this.beneficiaryPersonalDetails[key] == '')) {
                    this.missingValueFalg = true;
                }
            }
        }
        return this.missingValueFalg;
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostructionService.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    // Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls =
            this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW' ||
                this.stepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE' ||
                this.stepDetails.stepStatusDetails.stepStatusCode === 'SUBMIT';
    }
    updateProfile() {
        let a = window.location.href;
        if (a.toString().includes('/beneficiary-profile')) {
            window.location.href = window.location.origin + '/beneficiary-profile/profile?prop=BENE&section=1';
        }
        else {
            sessionStorage.setItem('listBeneficiaryId', this.beneficiaryPersonalDetails.beneficiaryId);
            // sessionStorage.setItem('bene-profile-viewMode', 'true');
            let url;
            if (this.userType === RolesRouteMap.ATTORNEY) {
                url = [`${RolesRouteMap.userRoleRouteMapping[this.userType]}/attorney/beneficiary/profile`];
            }
            else {
                url = [`${RolesRouteMap.userRoleRouteMapping[this.userType]}/beneficiaries/profile`];
            }
            sessionStorage.setItem('bene-update-profile', 'true');
            sessionStorage.removeItem('bene-update-experience');
            this.router.navigate(url, { state: { redirectUrl: this.router.url, redirectPage: 'Back to Petition Builder' } });
        }
    }
    getBenDataProfile() {
        this.getBeneProfileInformation();
    }
    onDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseBeneficiaryPersonalDetailsLibraryService.ɵfac = function BaseBeneficiaryPersonalDetailsLibraryService_Factory(t) { return new (t || BaseBeneficiaryPersonalDetailsLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIBeneficiaryPersonalDetails), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.Router)); };
BaseBeneficiaryPersonalDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseBeneficiaryPersonalDetailsLibraryService, factory: BaseBeneficiaryPersonalDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseBeneficiaryPersonalDetailsLibraryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$1.Store }, { type: APIBeneficiaryPersonalDetails }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.Router }]; }, null); })();

/*
 * Public API Surface of base-beneficiary-personal-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIBeneficiaryPersonalDetails, BaseBeneficiaryPersonalDetailsLibraryService };
//# sourceMappingURL=base-beneficiary-personal-details-library.js.map
